module.exports = {
      id: "shorts-usage",
      viewBox: "0 0 19 19",
      url: __webpack_public_path__ + "svg-sprite-c16dead317bf40daa0a857495c90b974.svg#shorts",
      toString: function () {
        return this.url;
      }
    }